export type AdEvent = {
  isLar?: boolean;
  creativeId: string;
  duration: Number;
  sequence: Number;
};

export type AdBeginEvent = {
  creativeId?: string;
  title?: string;
  duration: Number;
  id: string;
  isLar?: Boolean;
  sequence?: Number;
};

export function adBegin(e: AdBeginEvent) {
  const { creativeId, title, duration, id, isLar, sequence } = e;
  return {
    creativeId: creativeId ?? '',
    title: title ?? id,
    sequence,
    duration,
    isLar,
  } as AdEvent;
}
